import { FaInstagram, FaYoutube, FaEnvelope } from "react-icons/fa";

export default function Contact() {
  return (
    <div className="container contact page-content">
      <h2>Contact Us</h2>
      <div className="contact-icons">
        {/* Email */}
        <a href="mailto:Clintonupeter89@gmail.com" aria-label="Email">
          <FaEnvelope />
        </a>

        {/* Instagram */}
        <a
          href="https://www.instagram.com/fluxlyvibe"
          target="_blank"
          rel="noreferrer"
          aria-label="Instagram"
        >
          <FaInstagram />
        </a>

        {/* YouTube */}
        <a
          href="https://youtube.com/@roarashu"
          target="_blank"
          rel="noreferrer"
          aria-label="YouTube"
        >
          <FaYoutube />
        </a>
      </div>

      <p className="contact-note">
        Please contact only via Email or Instagram DM. WhatsApp support will be
        added soon.<p> © DoodleCart</p>
      </p>
    </div>
  );
}
